import { Link } from 'react-router-dom';
import { Logo } from '@/components/Logo';

export const SUPPORT_EMAIL = 'support.zorobabel@gmail.com';

export function LegalLinks({ className = '' }) {
  const a = 'hover:text-brand transition-colors';
  return (
    <div className={`flex flex-wrap gap-x-4 gap-y-1 text-xs text-muted-foreground ${className}`} data-testid="legal-links">
      <Link to="/privacy-policy" className={a} data-testid="legal-link-privacy">Confidentialité</Link>
      <Link to="/terms" className={a} data-testid="legal-link-terms">CGU</Link>
      <Link to="/delete-account" className={a} data-testid="legal-link-delete">Suppression de compte</Link>
    </div>
  );
}

export function LegalShell({ title, subtitle, children, testId }) {
  return (
    <div className="min-h-screen" data-testid={testId}>
      <header className="sticky top-0 z-40 border-b border-border glass">
        <div className="mx-auto flex max-w-4xl items-center justify-between px-4 py-3 sm:px-6">
          <Link to="/" aria-label="Accueil"><Logo variant="full" className="h-10" /></Link>
          <Link to="/" className="text-sm text-muted-foreground hover:text-white" data-testid="legal-back-home">← Retour au site</Link>
        </div>
      </header>
      <main className="mx-auto max-w-4xl px-4 pb-20 pt-10 sm:px-6">
        <h1 className="font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl">{title}</h1>
        {subtitle && <p className="mt-2 font-mono text-xs uppercase tracking-widest text-brand">{subtitle}</p>}
        <div className="mt-8">{children}</div>
        <footer className="mt-16 border-t border-border pt-6">
          <LegalLinks />
          <p className="mt-3 text-xs text-muted-foreground">MyMusic IA — ZOROBABEL · {SUPPORT_EMAIL}</p>
        </footer>
      </main>
    </div>
  );
}
